var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_c('div',{staticClass:"test__wrapper"},[_c('Section',{attrs:{"limiter":""}},[_c('div',{staticClass:"grid"},[_c('div',{staticClass:"grid__wrapper"},_vm._l((_vm.$places.data),function(item){return _c('GridItem',{key:item.id,attrs:{"params":item}})}),1)])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }